import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'baggageFormat'
})
export class BaggageFormatPipe implements PipeTransform {
  transform(info: any): any[] {
    const baggage = info?.extra_info?.baggage, pax = info?.segments?.[0]?.passengers;
    if (!baggage) return [];
    const typeMap: any = { '1': 'Adult', '2': 'Child', '3': 'Infant' };
    const grouped = pax?.reduce((a: any, p: any) => {
      const t = p?.type?.toLowerCase() || 'unknown';
      a[t] = (a[t] || 0) + 1;
      return a;
    }, {}) || {};
    if (Array.isArray(baggage)) {
      return [{ route: '', items: baggage.map((i, idx) => ({ type: i?.free_text?.trim() || 'Info', value: i?.value?.trim() || 'N/A', index: idx + 1 })) }];
    }
    return Object.entries(baggage).map(([r, pt]: any) => {
      const items: any[] = [], indexMap: any = {};
      Object.entries(pt).forEach(([k, v]: any) => {
        const t = typeMap[k] || `Pax ${k}`, gKey = t.toLowerCase(), count = grouped[gKey] || 0;
        for (let i = 0; i < count; i++) {
          Object.values(v).forEach(val => {
            const idx = (indexMap[t] = (indexMap[t] || 0) + 1);
            items.push({ type: t, value: String(val).trim() || 'N/A', index: idx });
          });
        }
      });
      return { route: r.replace(/_/g, '-').toLowerCase(), items };
    });
  }

}
